// Darstellung hell / dunkel / wie das System. Gemerkt je Browser (nur Komfort, darf fehlen).
export type Thema = "hell" | "dunkel" | "system";

const SCHLUESSEL = "imho3.thema";

export function gemerktesThema(): Thema {
  try {
    const wert = localStorage.getItem(SCHLUESSEL);
    if (wert === "hell" || wert === "dunkel" || wert === "system") return wert;
  } catch {
    // privates Fenster oder gesperrter Speicher: Systemvorgabe
  }
  return "system";
}

export function themaAnwenden(thema: Thema): void {
  const wurzel = document.documentElement;
  if (thema === "system") delete wurzel.dataset.theme;
  else wurzel.dataset.theme = thema === "dunkel" ? "dark" : "light";
}

export function themaSetzen(thema: Thema): void {
  themaAnwenden(thema);
  try {
    localStorage.setItem(SCHLUESSEL, thema);
  } catch {
    // ohne Speicher gilt die Wahl bis zum Neuladen
  }
  window.dispatchEvent(new CustomEvent("imho:thema", { detail: thema }));
}
